"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var base_from_domain_converter_1 = require("../base-from-domain.converter");
var controller_model_1 = require("../../../layout-models/form-models/controller.model");
var lodash_1 = require("lodash");
var FormControllerFromDomainConverter = /** @class */ (function (_super) {
    __extends(FormControllerFromDomainConverter, _super);
    function FormControllerFromDomainConverter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormControllerFromDomainConverter.prototype.apply = function (controllerCell) {
        var domainControl = controllerCell.controlModel;
        return new controller_model_1.ControllerModel(controllerCell.id, domainControl.metaControl, true, controllerCell.properties.columnCount.m, domainControl.bindings, lodash_1.isEmpty(domainControl.actions)
            ? domainControl.metaControl.defaultActions
            : domainControl.actions, domainControl.properties.toJS(), domainControl.fields, controllerCell.properties.visibility, controllerCell.title);
    };
    return FormControllerFromDomainConverter;
}(base_from_domain_converter_1.BaseFromDomainConverter));
exports.FormControllerFromDomainConverter = FormControllerFromDomainConverter;
//# sourceMappingURL=form-controller-from-domain.converter.js.map